export interface Chain {
  id: string;
  sfid: string;
  name: string;
  is_active: boolean;
  draft_rate_plan_count?: number;
}

export function draftRatePlanCountLabel(count: number): string | null {
  if (count <= 0) {
    return null;
  }
  return count === 1 ? '1 draft' : `${count} drafts`;
}
